import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Terminal} from 'xterm';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-xterm',
  templateUrl: './xterm.component.html',
  styleUrls: ['./xterm.component.scss'],
})
export class XtermComponent implements OnInit, AfterViewInit {

  public term: Terminal;
  container: HTMLElement;
  @ViewChild('terminal', {static: false}) terminalDiv: ElementRef;

  constructor() { }

  ngOnInit() {
    return;
  }

  prompt = () => {
    this.term.write('\r\n$ ');
  };


  ngAfterViewInit() {
    setTimeout(() => {
      this.term = new Terminal();
      this.term.open(this.terminalDiv.nativeElement);
      this.term.writeln('Welcome to console');
      this.prompt();
      this.term.onKey((e, domEvent) => {
        const ev = e.domEvent;
        const printable = !ev.altKey && !ev.ctrlKey && !ev.metaKey;

        if (ev.keyCode === 13) {
          this.prompt();
        } else if (ev.keyCode === 8) {
          // Do not delete the prompt
          if (this.term.buffer.active.length > 2) {
            this.term.write('\b \b');
          }
        } else if (printable) {
          this.term.write(e.key);
        }
/*
        this.term.write(`${key}`);
        this.term.focus();
        console.log(`Key entered: ${key}`);
*/
      });
    }, 1000);
  }
}
